<app-page-title [heading]="heading" [subheading]="subheading" [icon]="icon"></app-page-title>
<app-regular></app-regular>
